import React from "react";

export default function Notes() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <g id="Notes" transform="translate(-854 -6)">
        <path
          id="Caminho_10332"
          data-name="Caminho 10332"
          d="M17.222,4.778v8H12.778v4.444h-8V4.778H17.222m0-1.778H4.778A1.783,1.783,0,0,0,3,4.778V17.222A1.783,1.783,0,0,0,4.778,19h8.889L19,13.667V4.778A1.783,1.783,0,0,0,17.222,3ZM11,12.778H6.556V11H11Zm4.444-3.556H6.556V7.444h8.889Z"
          transform="translate(851 3)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
